'use client'
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import Head from 'next/head';
import { Mail, Lock, LogIn } from 'lucide-react';
import { useAuth } from '../../components/AuthProvider';

axios.interceptors.request.use(
(
config) => {
if (typeof window !== 'undefined') {
const token = localStorage.getItem('authToken');
if (token) {
config.headers['Authorization'] = `Bearer ${token}`;
}
}
return config;
},
(error) => {
return Promise.reject(error);
}
);

const LoginPage = () => {
const [email, setEmail] = useState('test@user.com');
const [password, setPassword] = useState('AI6y7nrNAC');
const [error, setError] = useState('');
const router = useRouter();
const { isAuthenticated, loading } = useAuth();

useEffect(() => {
    if (isAuthenticated) {
        router.push('/dashboard');
    }
}, [isAuthenticated, router]);

const handleLogin = async (e) => {
e.preventDefault();
setError('');
try {
const apiUrl = process.env.NEXT_PUBLIC_API_URL || '';
const response = await axios.post(`${apiUrl}/login`, { email, password });
const { token } = response.data;
localStorage.setItem('authToken', token);
router.push('/dashboard');
} catch (err) {
setError('Неверный логин или пароль.');
}
};

if (loading || isAuthenticated) {
    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-50 dark:bg-[#0F172A]">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
        </div>
    );
}

return (
<>
<Head><title>Авторизация</title></Head>
<div className='flex flex-col justify-center items-center min-h-screen auth-bg px-4'>
    <div className="mb-8 text-center">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2 tracking-tight">Авторизация</h1>
        <p className="text-gray-500 dark:text-gray-400">Добро пожаловать обратно</p>
    </div>

    <div className='bg-white dark:bg-[#1E293B] p-8 rounded-2xl shadow-2xl w-full max-w-md border border-gray-200 dark:border-gray-800/50 backdrop-blur-sm'>
        <form onSubmit={handleLogin} className="space-y-5">
            <div>
                <label className='block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider mb-2'>Email адрес</label>
                <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Mail className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                        type='email'
                        className='w-full pl-10 p-3 rounded-xl bg-gray-50 dark:bg-[#0F172A] text-gray-900 dark:text-white border border-gray-200 dark:border-gray-700 focus:border-indigo-500 dark:focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 outline-none transition-all'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    placeholder="name@example.com"
                    required
                    />
                </div>
            </div>
            <div>
                <label className='block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider mb-2'>Пароль</label>
                <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Lock className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                        type='password'
                        className='w-full pl-10 p-3 rounded-xl bg-gray-50 dark:bg-[#0F172A] text-gray-900 dark:text-white border border-gray-200 dark:border-gray-700 focus:border-indigo-500 dark:focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 outline-none transition-all'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    required
                    />
                </div>
            </div>
            {error && <div className='text-red-500 text-sm p-3 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-100 dark:border-red-900/50'>{error}</div>}
            <button
                type='submit'
                className='w-full flex justify-center items-center gap-2 p-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-semibold transition-all shadow-lg shadow-indigo-500/30'
            >
                <LogIn className="h-5 w-5" />
                Войти в систему
            </button>
        </form>
        <div className='mt-6 text-center text-sm text-gray-600 dark:text-gray-400'>
            <p>Нет аккаунта? <Link href='/register' className='text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300 font-semibold transition-colors'>Зарегистрироваться</Link></p>
        </div>
    </div>

    <div className="mt-12 text-xs text-gray-500 dark:text-gray-500">
        &copy; {new Date().getFullYear()} Все права защищены.
    </div>
</div>
</>
);
};

export default LoginPage;